import { MyComponentType } from '../../component-factory/component-types';
import { ComponentIdEnum } from '../../component-factory/ComponentIdEnum';
import { ElementConfigType } from '../../store/type';
import { PageEditorStoreContext } from '../../store/PageEditorStore';
import React, { useContext, useEffect } from 'react';
import lozad from 'lozad';
import './VideoV2Component.scss';
import { lazy } from 'ice';
import { ConfigHOC } from '../../HOC';

export const VideoV2Component: MyComponentType<ElementConfigType> = (props: ElementConfigType) => {
  const { id, privateSchema, parentNodeIsBody } = props;
  const pageEditorStore = useContext(PageEditorStoreContext);

  useEffect(() => {
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
    const tag = document.createElement('script');

    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
  }, []);

  const videoSrc = privateSchema?.autoPlay
    ? `${privateSchema?.src || props.config.src}?autoplay=1&mute=1`
    : privateSchema?.src || props.config.src;

  return (
    <div
      style={Object.assign(
        parentNodeIsBody || pageEditorStore.isDevelopment ? { paddingTop: 16, paddingBottom: 16 } : {},
        {
          width: '100%',
          display: 'block',
        },
      )}
    >
      <div id={id}>
        <div className="video_v2_container" id="player">
          <iframe
            width="560"
            height="315"
            // src={videoSrc}
            allowFullScreen
            allow="autoplay"
            className="lozad"
            data-src={videoSrc}
          />
        </div>
      </div>
    </div>
  );
};

const ConfigForm = lazy(() => import('../../components-with-definition/VideoV2ComponentDefinition'));

VideoV2Component.definition = {
  id: ComponentIdEnum.VIDEO_V2_COMPONENT,
  name: '视频组件_2',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/z6ubyOL_xMk4jCAWhwSfL.png?image_process=resize,w_200',
  position: 15, // 显示顺序
  config: {
    text: '这是一个外链视频容器（目前支持youtube）',
    src: 'https://www.youtube.com/embed/TgbtenvYMb4',
  },
  privateSchema: {
    autoPlay: true,
  },
  category: 'media',
  configForm: ConfigHOC(ConfigForm),
};
